import { useWatch } from 'react-hook-form';
import { LeadsSearchResponseItem } from 'components/forms/domain/lead/LeadSearchField.types';

const useSearchedAutomatedReviewLogsLeadUid = (): string | undefined => {
  const searchedLead: LeadsSearchResponseItem[] | undefined = useWatch({
    name: 'lead',
  });

  if (!searchedLead?.length) {
    return undefined;
  }

  const [chosenLead] = searchedLead;

  return chosenLead.uid;
};

export default useSearchedAutomatedReviewLogsLeadUid;
